import Vue from 'vue'
import { isCurrentAppIn } from '@/utils/app.js'
import { access } from '@/utils/featureset.js'
const lodash = require('lodash')

// TODO: Подумать! Возможно, надо при логине указывать тип клиента: 'mik', 'doc' и с данными по логину возвращать featureset
// с помощью которого уже настраивается вид приложения. В таком случае типа клиента втыкается в сокет.
// Но с другой стороны сервис Contract вообще не должен знать о типах приложений! Их могут быть десятки...
//
// Формат:
//
// фича: {
//   crud: ['create_apps_list', 'read_apps_list', 'update_apps_list', 'delete_apps_list'],
//   сабфича: { // может не быть
//     crud: ['create_apps_list', 'read_apps_list', 'update_apps_list', 'delete_apps_list'],
//     ...
//   },
//   ...
// }
//
// Пример 1:
//
// claim: {
//   crud: [null, 'mik', null, null],
//   journal: { // это зависимая от claim фича. Если crud у claim будет пустой, то claim исчезнет вместе со всеми зависимыми фичами, даже если в них crud не пустой
//     crud: [null, 'mik,doc', null, null]
//   }
// },
//
// Пример 2:
//
// claim: {
//   crud: [null, 'mik', null, null],
// },
// claim_journal: { // это независимая от claim фича...
//   crud: [null, 'mik', null, null]
// }
//

export const featureset = getFeaturesetProjection({
  dashboard: {
    crud: [null, 'mik', null, null]
  },
  claim: {
    crud: [null, 'mik', null, null],
    journal: { // это зависимая от claim фича. Если crud у claim будет пустой, то claim исчезнет вместе со всеми зависимыми фичами
      crud: [null, 'mik', null, null]
    }
  },
  procedure: {
    crud: [null, 'mik', null, null]
  },
  contract: {
    crud: ['doc', 'mik,doc', 'doc', 'doc'],
    document: {
      crud: ['doc', 'doc', 'doc', 'doc']
    },
    template: {
      crud: ['doc', 'doc', 'doc', 'doc']
    },
    journal: {
      crud: [null, 'doc,mik', null, null]
    }
  },
  order: {
    crud: ['doc', 'mik,doc', 'doc', 'doc'],
    journal: {
      crud: [null, 'doc,mik', null, null]
    }
  },
  report: {
    crud: ['mik', 'mik', null, null]
  },
  help: {
    crud: [null, 'mik,doc', null, null]
  },
  settings: {
    crud: [null, 'mik,doc', 'mik,doc', null]
  },
  about: {
    crud: [null, 'mik,doc', null, null]
  },
  demo: {
    crud: [null, 'mik', null, null]
  },
  draft: {
    crud: ['dev', 'dev', 'dev', 'dev']
  },
  color: {
    crud: ['dev', 'dev', 'dev', 'dev']
  },
  svg: {
    crud: ['dev', 'dev', 'dev', 'dev']
  }
})

Vue.prototype.$access = access

function prj (action, apps) {
  return isCurrentAppIn((apps || '').split(',')) ? action : ''
}

function getFeaturesetProjection (obj) {
  return lodash.transform(obj, (acc, value, key) => {
    if (lodash.has(value, 'crud')) {
      const crud = `${prj('c', value.crud[0])}${prj('r', value.crud[1])}${prj('u', value.crud[2])}${prj('d', value.crud[3])}`
      if (crud) {
        acc[key] = { ...getFeaturesetProjection(value), crud: crud }
      }
    }
  }, {})
}
